import { render, staticRenderFns } from "./MyPortfoliosStatic.vue?vue&type=template&id=1f4743b1&scoped=true&"
import script from "./MyPortfoliosStatic.vue?vue&type=script&lang=js&"
export * from "./MyPortfoliosStatic.vue?vue&type=script&lang=js&"
import style0 from "./MyPortfoliosStatic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MyPortfoliosStatic.vue?vue&type=style&index=1&id=1f4743b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4743b1",
  null
  
)

export default component.exports